import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=31db3be4&scoped=true"
import script from "./UploadCard.vue?vue&type=script&lang=js"
export * from "./UploadCard.vue?vue&type=script&lang=js"
import style0 from "./UploadCard.vue?vue&type=style&index=0&id=31db3be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db3be4",
  null
  
)

export default component.exports